<template>
  <v-container v-if="unity" class="mb-12">
    <v-breadcrumbs :items="breadcrumbs" class="mt-2"></v-breadcrumbs>
    <div style="max-width: 1400px">
      <v-btn :to="{ name: 'unities' }" exact text>
        <v-icon left>mdi-arrow-left</v-icon>
        {{ __("Voltar", "unities") }}
      </v-btn>
      <v-row class="mt-3">
        <v-col cols="12" md="4" lg="3">
          <v-card flat>
            <v-img
              contain
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDQ0NDQ0PDQ0NDw0NDg8ODRANDQ0NFREWFhURFRUYHSggGBolGxgTITEhJSkrLi4uFx8zODMtNygtLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAMkA+wMBIgACEQEDEQH/xAAbAAEBAQEBAQEBAAAAAAAAAAAAAQUGBAMCB//EADYQAQACAAIFCAkEAwEAAAAAAAABAgMRBAUSITETFUFRUpLB0SIyM1NhcYKRokJyobGBsuFi/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AP6EigCZKgKioCgAAAgqSAoAAAIoAAAAAigIqKAAAIoCKgCgAioAQoAAAACAAoAIoAAAAAgoAkqkgCoAoAAAIqAoACZKgKioCgACSoIBIKAACAqKgKIoCKgKCSBAQSCiKAAAioCgAIqAqKgKAAACEkkgoPvgaFiYnq0nLtW9GoPgtazM5REzPVEZy2NH1NWN+JabfCvox5tDDwqYUejFaR08I+8gxdH1TiX9bLDj477fZpYGq8KmUzG3PXbfH24PzpGtcOm6ueJP/n1fu8uja1vfFrFoitLTs5Rv3zwnMHy11gbGJFojKLx0dqOPgz3Ra1wOUwbZetX04/xxj7ZudAAASVSQICAFAAAARUBQAEVAVFQFBAUerR9XYuJv2dmOu27+OLT0fU+HXfeZvPdr9gYmHh2vOVazafhGbQ0fU17b72ikdUelbybNa1plWIisdERlD9g8uj6vwsPhXOe1b0pfrSNNw8P1rxn1Rvt9nz0jRMTEzice1YnorWIj78Xl5jj3s92AfPSNczO7Drs/G2+fszsbGviTne02+fD7cGrzJHvZ7sHMce9nuwDHTP79HzbPMce9nuwcxx72e7ANDQ8blcOt+uN/z4S53TMHk8S9OiJzr+2d8N/QdE5Gs125tEznGcZZbnz07V8Y1q22prMRluiJzgHPDY5kj3s92EtqWIiZ5Wd0TPqwDISSFBIJABQAAARUBQAAQFRUBX10XG5PEpfoid/y4S+SA67PdnG/p3dLCx9b4lt1IjDjvW8mjqjH28GvXT0J/wAcP4ZOtcHYxrdV/Tj5zx/kH61ZebaRSbTNp9LfM5z6stjWGkzg4cXiItviuUzlxYuqfb0+r/WWlrz2P118Qebnu3u696fI57v7uvenyZTUwNTWtXO99iZ/TFdrL57wOe7e7r3p8l57t7uvenyeLTNEtg2ytlMTviY4S84NXnu3u696fI57t7uvenyZaA1ee7e7r3p8jnu3u696fJlKDTnXdvd170+TYvOdJnrrP9OTng6ufU+nwBykKkAKhACiQoAACKgBkAECoBIAAqA0NS4+zi7E8MSMvqjh4vdrvB2sPbjjhzn9M7p8GHS01mLRxrMTHzh1FLRi4cT+m9f4mAYOqPb0+r/WWlrz2P118Wfq7DmmlVpPGs3j8Z3tDXnsfrr4gxtFtFcTDtO6IvWZ+EZuqchk9WDp+LSNmt93RFoi2X3Boa/vGxSv6traj4VymJ/uGK/WJebzNrTNrTxmX5AbWqdBjYm+JG/EiaxE9FJ8/J4tV6Jyt87R6FMpnqmeirogcppGFOHe1J/TOWfXHRL5urtg0m23NKzaIyzmImcmJrvC2cXa6Lxn/mN0+AM6eDrJ9T6fBykusn1Pp8AclEKQSAAAEKCAAZAAoACKgKioCgANrUWNnS2HPGk5x+2f+/2xXo1djcni1nPKJ9G3yn/uQNbGwMtKwsSOF4tWf3RWfD+k157H66+LQmsTlnHCc4+E5ZPBrz2Mfvr4gwRM2zqrV+WWLiRv40r1fGfiD8aPqjaw5m8zW876xx2Y6p63ivoOJXEjDmu+05VmPVmOvN0wD5aNgRhUileEdPTM9MvqADO13hZ4W100mJ/xO6fBovxj4e3S1Z/VEx94ByduDq59T6fByl4yzieMZxPzh1c+p9PgDlIJIAAgBRFAAARUBQSAVFQFRUBQQFQAdNq7H5TCpbpy2bfujc+GvPY/XXxePUmkRW1qWmIi0bUTM5RtR/z+mxy1O3XvQDla2ymJjjE574zh6+dMbt/hXyb/AC1O3TvQctTt070AwOdMbt/hXyOdMbt/hXyb/LU7dO9By1O3TvQDA50xu3+FfI50xu3+FfJv8tTt070HLU7dO9AMDnTG7f4V8jnTG7f4V8m/y1O3TvQctTt070A5XEtNptaeM5zO7Le6qfU+nwOWp26d6H5xMamzb068J/VHUDloVI4AEBACiKAAAioCgmYKioCoqAoICiKCGQSBl8DKFQDL4GRmAZQZfBUAyMoADL4GSoCpISAEEgKigAAIAKIAoICiAKIAogCoAKIAogCiAKIAogCiKAIAoigCAKgACoCoqAAACoACggAAAAqAAACoAAACggACooICggAEBABAQABIAAASSSAEgBkKCAQAAAEAAAAAAAAAAEAAA//Z"
            ></v-img>
          </v-card>
          <v-card class="mt-2" flat>
            <v-card-text>
              <ScopeProvider scope="unities.edit">
                <UnityEdit :value="unity" />
              </ScopeProvider>
              <ScopeProvider scope="auth.users.edit_status">
                <UnityLockUnlock :unity="unity" />
              </ScopeProvider>
              <ScopeProvider
                elevation="0"
                class="mt-3 red--text"
                scope="unities.delete"
              >
                <UnityRemove :unity="unity" />
              </ScopeProvider>
              <ScopeProvider scope="unities.hate">
                <UnityRating :unity="unity" :buttonRating="false" />
              </ScopeProvider>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-row>
            <v-col>
              <v-card flat>
                <v-card-title>
                  {{ unity.name }}
                  <UnityRating :unity="unity" :statusRating="false" />
                </v-card-title>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ __("Email", "unities", 1) }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ unity.email }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ __("Status", "unities", 1) }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ unity.is_active ? __("Ativo") : __("Bloqueado") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col>
              <div class="subtitle-2">
                {{ __("Disponibilidade", "unities") }}
              </div>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col
              cols="12"
              lg="6"
              v-for="unity_service_type in unity.unity_service_types"
              :key="unity_service_type.id"
            >
              <v-card flat>
                <v-card-title class="subtitle-1">
                  {{ unity_service_type.description }}
                </v-card-title>
                <v-card-text>
                  <v-row class="mb-2">
                    <v-col>
                      <v-icon>mdi-city-variant</v-icon>
                      {{ unity_service_type.country_areas.length }}
                      {{ __("distritos", "unities") }}
                    </v-col>
                    <v-col>
                      <v-icon>mdi-city</v-icon>
                      {{
                        unity_service_type.country_areas.reduce(
                          (partialSum, a) => partialSum + a.total_cities,
                          0
                        )
                      }}
                      {{ __("concelhos", "unities") }}
                    </v-col>
                  </v-row>
                  <v-chip
                    @click="
                      handleClickDistrict(country_area, unity_service_type.id)
                    "
                    v-for="country_area in unity_service_type.country_areas"
                    :key="country_area.id"
                    small
                    class="mr-1 mb-2"
                    link
                  >
                    {{ country_area.name }} ({{ country_area.total_cities }})
                  </v-chip>
                  <v-alert
                    type="warning"
                    text
                    dense
                    v-if="!unity_service_type.country_areas.length"
                  >
                    {{ __("A unidade não presta serviços de ", "unities") }}
                    {{ unity_service_type.description }}
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    @click="handleUpdateAvailability(unity_service_type)"
                    elevation="0"
                    class="info--text"
                  >
                    {{ __("Ajustar", "unities") }}
                  </v-btn>

                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        elevation="0"
                        class="info--text ml-2"
                      >
                        {{ __("Clonar", "unities") }}
                        <v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="item in unity.unity_service_types.filter(
                          (el) => el.id !== unity_service_type.id
                        )"
                        :key="item.id"
                        @click="handleCopyFrom(unity_service_type, item)"
                      >
                        {{ item.description }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <AvailabilityUpdateDialog
      ref="availabilityDialog"
      @submit="updateAvailability"
    />
    <AvailabilityCityUpdateDialog
      ref="availabilityCityDialog"
      @submit="updateAvailabilityCity"
    />
  </v-container>
</template>

<script>
import { show as showUnity } from "@/services/unities";
import UnityRemove from "../components/Unities/UnityRemove";
import UnityRating from "../components/Unities/UnityRating";
import UnityLockUnlock from "../components/Unities/UnityLockUnlock";
import UnityEdit from "../components/Unities/UnityEdit";
import ScopeProvider from "@/components/ScopeProvider";
import AvailabilityUpdateDialog from "@/components/unities/AvailabilityUpdateDialog.vue";
import AvailabilityCityUpdateDialog from "../components/unities/AvailabilityCityUpdateDialog.vue";
import {
  createForCountryAreas,
  copyFrom,
  createForCities,
  indexAvailabilities,
} from "@/services/unities/unity_service_types_service";
import i18n from "@/mixins/i18n";

export default {
  components: {
    AvailabilityUpdateDialog,
    AvailabilityCityUpdateDialog,
    UnityRemove,
    UnityRating,
    UnityLockUnlock,
    ScopeProvider,
    UnityEdit,
  },
  mixins: [i18n],
  data() {
    return {
      unity: null,
    };
  },
  methods: {
    async handleClickDistrict(district, service_type_id) {
      const data = await indexAvailabilities(
        this.unity.id,
        service_type_id,
        district.id
      );
      const selectedCities = data.map((availability) => availability.city_id);

      this.$refs.availabilityCityDialog.init(
        district,
        service_type_id,
        selectedCities
      );
    },
    async findUnity() {
      const response = await showUnity({}, this.$route.params.id);
      this.unity = response.data;
    },
    handleUpdateAvailability(unity_service_type) {
      if (!this.unity) {
        return;
      }
      this.$refs.availabilityDialog.init({
        unity_service_type,
        countryAreas: unity_service_type.country_areas.map((item) => item.id),
      });
    },
    async updateAvailability(form) {
      this.$refs.availabilityDialog.close();

      try {
        const response = await createForCountryAreas(
          this.unity.id,
          form.unity_service_type.id,
          {
            district_ids: form.countryAreas,
          }
        );

        this.unity = response.data;
      } catch (error) {
        this.$refs.availabilityDialog.init(form);
      }
    },
    async handleCopyFrom(to_unity_service_type, from_unity_service_type) {
      const response = await copyFrom(this.unity.id, {
        from_id: from_unity_service_type.id,
        to_id: to_unity_service_type.id,
      });

      this.unity = response.data;
    },
    async updateAvailabilityCity(payload) {
      const { selected_cities, district, service_type_id } = payload;
      const response = await createForCities(
        this.unity.id,
        service_type_id,
        district.id,
        {
          city_ids: selected_cities,
        }
      );
      this.unity = response.data;
    },
  },

  created() {
    this.findUnity();
  },

  computed: {
    breadcrumbs() {
      return [
        {
          text: this.__("unidades", "unities"),
          to: { name: "unities" },
          exact: true,
        },
        {
          text: this.unity ? this.unity.name : "",
          disabled: true,
        },
      ];
    },
  },
};
</script>
